import { connect } from 'react-redux';

import FeedbackForm from './FeedbackForm.js';
// import { redux as apiRedux } from '../api';
import { redux } from '../api';

const { setApplicationInfo, setCurrentSearchInfo } = redux.actions;

const mapStateToProps = state => {
  return {
    user: state.api.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setApplicationData: data => {
      dispatch(setApplicationInfo(data));
    },
    setCurrentSearchInfoData: data => {
      dispatch(setCurrentSearchInfo(data));
    },
  };
};

const ConnectedFeedbackForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedbackForm);

export default ConnectedFeedbackForm;
